import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { BillingDetails } from "components/settings/billing-details";
import { Loading } from "components/common/loading";
import {
  fetchBillingDetailsAction,
  updateBillingDetailsAction,
  saveBillingDetailsAction,
  redirectToBillingAction
} from "actions/account-settings-actions";

class BillingDetailsPage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    if (this.props.isBillingDetailsLoading) {
      return <Loading />;
    }
    if (this.props.vip) {
      return browserHistory.push("/");
    }
    return (
      <BillingDetails { ...this.props } />
    );
  }
}

BillingDetailsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isBillingDetailsLoading: PropTypes.bool.isRequired,
  vip: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  billingDetails: state.accountSettings.billingDetails,
  isBillingDetailsLoading: state.accountSettings.isBillingDetailsLoading,
  isNoBillingDetails: state.accountSettings.isNoBillingDetails,
  slug: state.accountSettings.slug,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchBillingDetailsAction(accountId)),
  onRedirectToBilling: (accountId) => dispatch(redirectToBillingAction(accountId)),
  onSaveBillingDetails: (accountId, billingDetails) => dispatch(saveBillingDetailsAction(accountId, billingDetails)),
  onUpdateBillingDetails: (field, payload) => dispatch(updateBillingDetailsAction(field, payload))
});

export const BillingDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(BillingDetailsPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/billing-details-container.jsx